import { DailyProgress, DailyProgressItem, RemainingStats } from '../../../models';

export const getDailyProgress = (data: any): DailyProgress => {
  return {
    scheduleId: data.schedule_id,
    items: getDailyProgressItems(data.schedule_items || []),
    remainingStats: getRemainingStats(data.remaining_stats || {})
  };
}

export const getRemainingStats = (data: any): RemainingStats => {
  return {
    totalDistance: data.total_distance || 0,
    totalTime: data.total_time || 0
  };
}

export const getDailyProgressItem = (data: any): DailyProgressItem => {
  return {
    scheduleItemId: data.schedule_item_id,
    order: data.order,
    address: data.address,
    zip: data.zip,
    type: data.type,
    service: data.service,
    dumpsterSize: data.dumpster_size,
    materialDisposing: data.material_disposing,
    specialInstructions: data.special_instructions,
    contactName: data.contact_name,
    contactPhone: data.contact_phone,
    status: data.status,
    price: data.price,
    orderId: data.order_id,
    dumpYardType: data.dump_yard_type,
  };
}

export const getDailyProgressItems = (data: any[]): DailyProgressItem[] => {
  return data.map(getDailyProgressItem).sort((a, b) => parseInt(a.order) - parseInt(b.order));
}
